import { crmRequest } from '../../http'

export type ContactMergeField =
  | 'full_name'
  | 'email'
  | 'phone'
  | 'title'
  | 'salutation'
  | 'owner_user_id'
  | 'category_id'
  | 'status'
  | 'summary_html'
  | 'linkedin_url'
  | 'relation_since'
  | 'introduced_by_person_id'

/** Mirrors `schemas_contact_merge.py` (spec-68). */
export interface ContactBrief {
  id: string
  full_name: string
  email: string | null
  organisation_name: string | null
  is_founder: boolean
}

export interface ContactFieldDifference {
  field: ContactMergeField
  survivor: unknown
  other: unknown
  survivor_text?: string | null
  other_text?: string | null
}

export interface ContactMergeMoves {
  labels_moved: number
  labels_dropped: number
  organisations_moved: number
  organisations_folded: number
  lists_moved: number
  lists_folded: number
  activities: number
  agreements: number
  tasks: number
  mails: number
  consents: number
  card_scans: number
  saved_views: number
}

export interface ContactMergePreview {
  survivor: ContactBrief
  other: ContactBrief
  fields: ContactFieldDifference[]
  moves: ContactMergeMoves
  survivor_updated_at: string
  other_updated_at: string
}

export interface ContactMergeRequest {
  survivor_id: string
  other_id: string
  take_from_other: ContactMergeField[]
  expected: { survivor_updated_at: string; other_updated_at: string }
}

export function getContactMergePreview(survivorId: string, otherId: string): Promise<ContactMergePreview> {
  const search = new URLSearchParams({ survivor_id: survivorId, other_id: otherId })
  return crmRequest(`/contacts/merge-preview?${search.toString()}`)
}

/** Merges; the answer is the survivor's detail, of which only the id is used. */
export function mergeContacts(input: ContactMergeRequest): Promise<{ person_id: string }> {
  return crmRequest('/contacts/merge', { method: 'POST', body: JSON.stringify(input) })
}
